import { Component, inject, Injector, OnInit } from '@angular/core';
import { Database, get, ref, remove, set } from "@angular/fire/database";
import { AuthService } from 'src/app/services/auth.service';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-vscenarios',
  templateUrl: './vscenarios.component.html',
  styleUrls: ['./vscenarios.component.css']
})
export class VscenariosComponent extends BaseComponent implements OnInit {
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  scenarios: any = []
  scenarioids: any = []
  sortArray: any = []
  showinfo = false
  showScenarioIdModal = false
  scenario: any = {}
  newScenarioName = ''
  showScenarioDeleteModal = false
  showScenarioIdModalNew = false
  dosShowAllScenarios = false
  interactivityClassSearch = ''
  scenariosWithClass = new Set<string>()
  componentSearch = ''
  scenariosWithComponent = new Set<string>()

  constructor(injector: Injector, private authService: AuthService) {
    super(injector)
  }

  async ngOnInit(): Promise<void> {
    this.isAuthenticatedWithFirebase = await this.authService.initializeAuth(() => this.onSuccessfullLogin())
  }

  async signInWithGoogle() {
    this.isAuthenticatedWithFirebase = await this.authService.signInWithGoogle()
    if (this.isAuthenticatedWithFirebase) { await this.onSuccessfullLogin() }
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }

  async getData() {
    const scenarioRef = ref(this.database, 'scenarios');
    const snapshot = await get(scenarioRef);
    if (snapshot.exists()) {
      this.scenarioids = []
      const scenTemp = BaseComponent.toArray(snapshot.val());
      // show only version 2 scenarios ---------------
      this.scenarios = []
      scenTemp.forEach((scenario: any) => {
        if (this.dosShowAllScenarios == true) {
          this.scenarios.push(scenario)
        } else {
          if (scenario.isVersion2 == true) {
            this.scenarios.push(scenario)
          }
        }
      })
      this.scenarios.forEach((scenario: any) => {
        scenario.players = BaseComponent.toArray(scenario.players)
        this.scenarioids.push(scenario.id) // we need this to verify new uniques exercise id 
      })
      this.scenarios.sort((a: any, b: any) => (a.seqNo ?? 0) - (b.seqNo ?? 0))
    }
  }
  showAllScenarios() {
    this.dosShowAllScenarios = true
    this.getData()
  }

  hideAllScenarios() {
    this.dosShowAllScenarios = false
    this.getData()
  }

  edit(scenario: any) {
    if (scenario == null) { // add new exercise
      this.addNewScenario()
    } else {
      this.router.navigate(['vscenarioedit'], { queryParams: { id: scenario.id } })
    }
  }

  async createNewScenario() {
    this.showScenarioIdModalNew = false

    this.scenario = {
      name: this.newScenarioName,
      id: this.newScenarioName,
      isVersion2: true,
      description: "Describe your scenario here",
      cameraConfig: "",
      components:[],
      lessonplan:[],
      interactivities: []
    }
    await set(ref(this.database, 'scenarios/' + this.newScenarioName), this.scenario)
    await this.getData()
  }

  addNewScenario() {
    this.router.navigate(['vscenarioedit'], { queryParams: { id: -1 } })
  }
  async confirmDeleteScenario() {
    this.loader.show()
    await remove(ref(this.database, `scenarios/${this.newScenarioName}`));
    await this.getData()
    this.showScenarioDeleteModal = false
    this.loader.hide()
  }

  async remove(scenario: any) {
    this.newScenarioName = scenario.id
    this.showScenarioDeleteModal = true
  }

  searchByComponent() {
    const search = (this.componentSearch || '').trim().toLowerCase();
    this.scenariosWithComponent.clear();
    this.scenariosWithClass.clear();
    if (!search) return;
    this.scenarios.forEach((scenario: any) => {
      const components: any[] = scenario.components || [];
      const found = components.some((c: any) =>
        (c.name || '').toLowerCase().includes(search) ||
        (c.file || '').toLowerCase().includes(search)
      );
      if (found) this.scenariosWithComponent.add(scenario.id);
    });
  }

  searchByInteractivityClass() {
    const search = (this.interactivityClassSearch || '').trim().toLowerCase();
    this.scenariosWithClass.clear();
    this.scenariosWithComponent.clear();
    if (!search) return;
    this.scenarios.forEach((scenario: any) => {
      const interactivities: any[] = scenario.interactivities || [];
      const modifiers: any[] = scenario.modifiers || [];
      const lessonplan: any[] = scenario.lessonplan || [];
      const foundInteractivity = interactivities.some((i: any) => (i.class || '').toLowerCase().includes(search));
      const foundModifier = modifiers.some((m: any) => (m.class || '').toLowerCase().includes(search));
      const foundLessonplan = lessonplan.some((l: any) => (l.name || '').toLowerCase().includes(search));
      if (foundInteractivity || foundModifier || foundLessonplan) this.scenariosWithClass.add(scenario.id);
    });
  }

  openLink(exercise: any) {
    window.open(`https://virtex.cellpodium.com`, '_blank');
  }
  duplicateModalOpen(e: any) {
    this.showScenarioIdModal = true
    this.scenario = e
  }

  async saveDuplicateScenario() {
    this.loader.show()
    let newScenario = JSON.parse(JSON.stringify(this.scenario)) // deep clone
    newScenario.id = this.newScenarioName // id inside the node  has to match the property name
    newScenario.displayName = this.newScenarioName // can be changed later
    await set(ref(this.database, 'scenarios/' + this.newScenarioName), newScenario)
    this.showScenarioIdModal = false
    await this.getData()
    this.loader.hide()
  }
}
